<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">История заморозки</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Клиенты / Карточка клиента / {{ product_name }} /</span> История заморозки</div>
                </div>
              </v-col>
            </v-row>
            <v-sheet rounded="lg" class="mt-5 col-7" style="padding: 0 !important;">
              <v-data-table
                v-if="freezeList"
                :items="freezeList.data.documents"
                :headers="headersFreeze"
                :hide-default-footer="true"
                item-key="document.id"
                class="elevation-1 custom__table"
                no-data-text="Нет истории заморозок"
              >

              </v-data-table>
            </v-sheet>
          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import Header from "@/components/Header";
import Menu from "@/components/Menu";
import {getItem, setItem} from "@/helpers/persistanceStorage";
import {clientActionTypes} from "@/store/modules/client";

export default {
  name: "CardSubscribeHistory",
  props: ['client_id','product_id','product_name'],
  components: {
    Header,
    Menu,
  },
  data() {
    return {
      freezeList:[],
      headersFreeze: [
        {text: 'Дата заморозки', align: 'start', sortable: false, value: 'startdate'},
        {text: 'Количество дней', align: 'start', sortable: false, value: 'days'},
        {text: 'Название документа', align: 'start', sortable: false, value: 'document.name'},
      ],
    }
  },
  mounted() {
    this.client_id !== undefined ? setItem('card-subscribe-history-client_id',this.client_id) : this.client_id = getItem('card-subscribe-history-client_id');
    this.product_id !== undefined ? setItem('card-subscribe-history-product_id',this.product_id) : this.product_id = getItem('card-subscribe-history-product_id');
    this.product_name !== undefined ? setItem('card-subscribe-history-product_name',this.product_name) : this.product_name = getItem('card-subscribe-history-product_name');
    this.fetchFeed(this.client_id,this.product_id)
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      freezeList: state => state.client.freezeList,
      validationErrors: state => state.client.validationErrors,
    })
  },
  methods: {
    fetchFeed(client_id, product_id) {
      this.$store.dispatch(clientActionTypes.getFreezeList, {client_id, product_id}).then(data => {
        this.freezeList = data.data
        console.log(data)
      })
    },
  }
}
</script>

<style scoped>

</style>